/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  EInvoiceExpenseResponse,
  EInvoiceUblDto,
  GetExpensesByFlowIdRequest,
  GetPreviewDataParams,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class EInvoiceController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags e-invoice-controller
   * @name FindByFlowIds
   * @request POST:/api/v1/einvoice/expense/flow-id/list
   */
  findByFlowIds = (data: GetExpensesByFlowIdRequest, params: RequestParams = {}) =>
    this.http.request<EInvoiceExpenseResponse[], any>({
      path: `/v1/einvoice/expense/flow-id/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static findByFlowIdsPath = '/v1/einvoice/expense/flow-id/list'
  static findByFlowIdsMethod = 'POST'
  /**
   * No description
   *
   * @tags e-invoice-controller
   * @name GetPreviewData
   * @request GET:/api/v1/einvoice/{flowType}/resource/{resourceId}/preview
   */
  getPreviewData = (
    { flowType, resourceId, ...query }: GetPreviewDataParams,
    params: RequestParams = {},
  ) =>
    this.http.request<EInvoiceUblDto, any>({
      path: `/v1/einvoice/${flowType}/resource/${resourceId}/preview`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getPreviewDataPath = '/v1/einvoice/${flowType}/resource/${resourceId}/preview'
  static getPreviewDataMethod = 'GET'
}
